"use strict";

(() => {
  const runtimeStyleId = "codex-product-tag-layout-runtime";
  const shopAllRuntimeMarker = "codex-shop-all-mobile-runtime-20260526";

  function injectRuntimeStyles() {
    if (document.getElementById(runtimeStyleId)) return;

    const style = document.createElement("style");
    style.id = runtimeStyleId;
    style.textContent = [
      ".callout .card__information--with-label,.outlet .card__information--with-label{grid-template-columns:minmax(0,1fr)!important;gap:10px!important}",
      ".callout .card-information,.callout .card__information .card__colors-info,.callout .card__tag-wrapper,.outlet .card-information,.outlet .card__information .card__colors-info,.outlet .card__tag-wrapper{grid-column:1!important;grid-row:auto!important;width:100%!important}",
      ".callout .card__content .card__information--with-label .card__tag-wrapper,.outlet .card__content .card__information--with-label .card__tag-wrapper{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important}",
      `@media (max-width:920px){.shop-all-hero__inner,.shop-all-section.page-width,.shop-all-section--tight.page-width{padding-left:max(15px,env(safe-area-inset-left))!important;padding-right:max(15px,env(safe-area-inset-right))!important}}/* ${shopAllRuntimeMarker} */`,
    ].join("");
    document.head.appendChild(style);
  }

  function removeShopAllTvoTag() {
    const path = window.location.pathname || "";
    if (!path.includes("/collections/shop-all")) return;

    const tvoSection = document.getElementById("tvo-lenses");
    if (!tvoSection) return;

    tvoSection.querySelectorAll(".card__tag").forEach((tag) => {
      const text = (tag.textContent || "").replace(/\s+/g, " ").trim();
      if (text !== "TrueView Optics") return;

      const modalOpener = tag.closest("modal-opener");
      if (modalOpener) {
        modalOpener.remove();
        return;
      }

      tag.remove();
    });
  }

  function applyRunningCapDockOverrides() {
    const path = window.location.pathname || "";
    if (!path.includes("/collections/running-cap")) return;

    document.querySelectorAll("[data-runningcap-dock] a[data-runningcap-spy]").forEach((link) => {
      link.style.setProperty("right", "max(7px, env(safe-area-inset-right))", "important");
      link.style.setProperty("padding", "8px 6px", "important");
      link.style.setProperty("letter-spacing", "0", "important");
    });
  }

  function hydrateDeferredCardVariantImage(event) {
    const swatch = event.target?.closest?.(".card-js .swatch-wrapper[data-ids]");
    if (!swatch) return;

    const card = swatch.closest(".card-js");
    const media = card?.querySelector?.(".media");
    const selectedId = (swatch.dataset.ids || "").split(",")[0];
    if (!card || !media || !selectedId) return;

    const hasImage = Array.from(media.querySelectorAll(":scope > img")).some((image) => image.dataset.id === selectedId);
    if (hasImage) return;

    const template = Array.from(card.querySelectorAll("template[data-card-variant-image]")).find(
      (candidate) => candidate.dataset.id === selectedId
    );
    const image = template?.content?.querySelector?.("img")?.cloneNode(true);
    if (!image) return;

    media.insertBefore(image, media.querySelector(".callout-pip"));
  }

  function bindDeferredCardVariantImages() {
    if (window.twoNuDeferredCardVariantImagesReady) return;
    window.twoNuDeferredCardVariantImagesReady = true;
    document.addEventListener("click", hydrateDeferredCardVariantImage, true);
  }

  async function refreshRunningCapSections() {
    const path = window.location.pathname || "";
    if (!path.includes("/collections/running-cap")) return;

    const pageText = document.body?.innerText || "";
    const hasBrokenPlaceholders =
      pageText.includes("{{ rich_text_heading }}") ||
      pageText.includes("{{ rich_text_body }}") ||
      pageText.includes("two_nu.phase2b.sections_rich_text_liquid");
    const hasExpectedIntro =
      Boolean(document.getElementById("runningcap-intro-heading")) &&
      pageText.includes("Shade first, lens second.") &&
      pageText.includes("The Running Cap solves the part of bright outdoor training");
    const hasExpectedProduct = pageText.includes("Running Cap: lightweight shade that works with your sunglasses");
    const hasExpectedDock = Boolean(document.querySelector("[data-runningcap-dock]"));
    const hasRunningCapRedVariant = Boolean(document.querySelector('[data-variant="RC-RED"]'));
    const hasRunningCapRedSwatch = Boolean(
      document.querySelector(
        '.swatch-wrapper[data-ids*="53617597251857"], .swatch-wrapper[data-frame-color="#750a0a"][data-lenses-color="#750a0a"]'
      )
    );
    const hasRunningCapTagPopups = [
      '[id$="__runningcap_products_live_20260527"] [class*="card__tag--upf50-"]',
      '[id$="__runningcap_products_live_20260527"] [class*="card__tag--breathable-"]',
      '[id$="__runningcap_products_live_20260527"] [class*="card__tag--lightweight-"]',
      '[id$="__runningcap_products_live_20260527"] [class*="card__tag--adjustable-"]',
      '[id$="__runningcap_products_live_20260527"] [class*="card__tag--sunglasses-pocket-"]',
    ].every((selector) => Boolean(document.querySelector(selector)));
    const hasStaleSections = Boolean(
      document.querySelector(
        [
          '[id^="shopify-section-template--"][id$="__image_banner_aiLgiP"]',
          '[id^="shopify-section-template--"][id$="__rich_text_kaqJat"]',
          '[id^="shopify-section-template--"][id$="__callout_QdXTJe"]',
          '[id^="shopify-section-template--"][id$="__multicolumn_hCzdMa"]',
          '[id^="shopify-section-template--"][id$="__collapsible_content_TPhcXR"]',
        ].join(",")
      )
    );

    if (
      document.querySelector("[data-running-cap-redesign]") &&
      !hasBrokenPlaceholders &&
      hasExpectedIntro &&
      hasExpectedProduct &&
      hasExpectedDock &&
      !hasStaleSections &&
      hasRunningCapTagPopups &&
      (!hasRunningCapRedVariant || hasRunningCapRedSwatch)
    ) {
      applyRunningCapDockOverrides();
      return;
    }

    const prefixSource = document.querySelector(
      [
        '[id^="shopify-section-template--"][id$="__callout_QdXTJe"]',
        '[id^="shopify-section-template--"][id*="__runningcap_"]',
        '[id^="shopify-section-template--"]',
      ].join(",")
    );
    const templatePrefix = prefixSource?.id?.match(/^shopify-section-(template--\d+)__/)?.[1];
    if (!templatePrefix) return;

    const sectionIds = [
      "runningcap_format_live_20260527",
      "runningcap_hero_live_20260527",
      "runningcap_dock_live_20260527",
      "runningcap_intro_live_20260527",
      "runningcap_products_live_20260527",
      "runningcap_details_anchor_live_20260527",
      "runningcap_features_live_20260527",
      "runningcap_support_live_20260527",
    ];

    const url = new URL(window.location.href);
    url.searchParams.set("view", "runningcap");
    let sections;
    try {
      sections = {};
      for (let index = 0; index < sectionIds.length; index += 5) {
        const sectionBatch = sectionIds.slice(index, index + 5);
        const batchUrl = new URL(url.toString());
        batchUrl.searchParams.set("sections", sectionBatch.map((sectionId) => `${templatePrefix}__${sectionId}`).join(","));
        batchUrl.searchParams.set("codex_nocache", `runningcap-section-refresh-${Date.now()}-${index / 5}`);
        const response = await fetch(batchUrl.toString(), {
          credentials: "same-origin",
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });
        if (!response.ok) return;
        Object.assign(sections, await response.json());
      }
    } catch {
      return;
    }

    const parseSection = (html) => {
      if (!html) return null;
      const template = document.createElement("template");
      template.innerHTML = html.trim();
      return template.content.firstElementChild;
    };

    const sectionElementId = (sectionId) => `shopify-section-${templatePrefix}__${sectionId}`;
    const freshSection = (sectionId) => parseSection(sections[`${templatePrefix}__${sectionId}`]);
    const initializeSection = (element) => {
      if (!element) return;
      window.Alpine?.initTree?.(element);
    };
    const executeSectionScripts = (element) => {
      if (!element) return;
      element.querySelectorAll("script").forEach((script) => {
        const freshScript = document.createElement("script");
        Array.prototype.slice.call(script.attributes).forEach((attribute) => {
          freshScript.setAttribute(attribute.name, attribute.value);
        });
        freshScript.textContent = script.textContent;
        script.replaceWith(freshScript);
      });
    };
    const replaceWithFresh = (current, sectionId) => {
      const fresh = freshSection(sectionId);
      if (!current || !fresh) return null;
      current.replaceWith(fresh);
      initializeSection(fresh);
      return fresh;
    };

    const insertBefore = (sectionId, beforeSectionId) => {
      const existing = document.getElementById(sectionElementId(sectionId));
      if (existing) return replaceWithFresh(existing, sectionId);
      const next = document.getElementById(sectionElementId(beforeSectionId));
      const fresh = freshSection(sectionId);
      if (!fresh || !next?.parentNode) return null;
      next.parentNode.insertBefore(fresh, next);
      initializeSection(fresh);
      return fresh;
    };

    const insertAfter = (sectionId, afterSectionId) => {
      const existing = document.getElementById(sectionElementId(sectionId));
      if (existing) return replaceWithFresh(existing, sectionId);
      const previous = document.getElementById(sectionElementId(afterSectionId));
      const fresh = freshSection(sectionId);
      if (!fresh || !previous?.parentNode) return null;
      previous.parentNode.insertBefore(fresh, previous.nextSibling);
      initializeSection(fresh);
      return fresh;
    };

    const replaceSection = (staleSectionId, freshSectionId) => {
      const stale = document.getElementById(`shopify-section-${templatePrefix}__${staleSectionId}`);
      const existing = document.getElementById(sectionElementId(freshSectionId));
      return replaceWithFresh(existing || stale, freshSectionId);
    };

    insertBefore("runningcap_format_live_20260527", "image_banner_aiLgiP");
    replaceSection("image_banner_aiLgiP", "runningcap_hero_live_20260527");
    executeSectionScripts(insertAfter("runningcap_dock_live_20260527", "runningcap_hero_live_20260527"));
    replaceSection("rich_text_kaqJat", "runningcap_intro_live_20260527");
    replaceSection("callout_QdXTJe", "runningcap_products_live_20260527");
    insertAfter("runningcap_details_anchor_live_20260527", "runningcap_products_live_20260527");
    replaceSection("multicolumn_hCzdMa", "runningcap_features_live_20260527");
    replaceSection("collapsible_content_TPhcXR", "runningcap_support_live_20260527");
    applyRunningCapDockOverrides();
    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("twoNu:viewportchange"));
  }

  function bootRuntimeFixes() {
    injectRuntimeStyles();
    bindDeferredCardVariantImages();
    removeShopAllTvoTag();
    applyRunningCapDockOverrides();
    refreshRunningCapSections();
    window.setTimeout(removeShopAllTvoTag, 250);
    window.setTimeout(removeShopAllTvoTag, 900);
    window.setTimeout(applyRunningCapDockOverrides, 300);
    window.setTimeout(refreshRunningCapSections, 300);
    window.setTimeout(applyRunningCapDockOverrides, 1200);
    window.setTimeout(refreshRunningCapSections, 1200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootRuntimeFixes);
  } else {
    bootRuntimeFixes();
  }

  document.addEventListener("shopify:section:load", bootRuntimeFixes);

  Alpine.data("calloutSlider", () => ({
    init() {
      removeShopAllTvoTag();

      const slider = this.$root.querySelector("swiper-container");
      if (slider) {
        const initializeButtons = () => {
          const swiper = slider.swiper;
          if (!swiper) {
            requestAnimationFrame(initializeButtons);
            return;
          }

          const updateButtons = () => {
            const root = slider.shadowRoot;
            if (!root) return;
            const previous = root.querySelector(".swiper-button-prev");
            const next = root.querySelector(".swiper-button-next");
            if (previous) previous.style.display = swiper.isBeginning ? "none" : "";
            if (next) next.style.display = swiper.isEnd ? "none" : "";
          };

          swiper.on("slideChange", updateButtons);
          swiper.on("resize", updateButtons);
          updateButtons();
        };

        initializeButtons();
      }

      const gridWrap = this.$root.querySelector(".callout__grid-wrap");
      const previousButton = this.$root.querySelector(".callout__grid-button--prev");
      const nextButton = this.$root.querySelector(".callout__grid-button--next");

      if (gridWrap instanceof HTMLElement && previousButton instanceof HTMLButtonElement && nextButton instanceof HTMLButtonElement) {
        const scrollAmount = () => gridWrap.clientWidth * 0.9 || 0;
        previousButton.addEventListener("click", () => {
          const amount = scrollAmount();
          if (amount) gridWrap.scrollBy({ left: -amount, behavior: "smooth" });
        });
        nextButton.addEventListener("click", () => {
          const amount = scrollAmount();
          if (amount) gridWrap.scrollBy({ left: amount, behavior: "smooth" });
        });
      }
    },
  }));
})();

/* CODEX_BOGO_VISIBLE_PIP_ASSET_FALLBACK_20260703_START */
(() => {
  const marker = "CODEX_BOGO_VISIBLE_PIP_ASSET_FALLBACK_20260703";
  if (window.__twoNuBogoVisiblePipAssetFallbackReady) return;
  window.__twoNuBogoVisiblePipAssetFallbackReady = true;
  if (!/\/pages\/buy-1-get-1-free\b/i.test(window.location.pathname)) return;

  const visible = (button) => {
    if (!button || button.hidden) return false;
    const style = getComputedStyle(button);
    const rect = button.getBoundingClientRect();
    return style.display !== "none" && style.visibility !== "hidden" && rect.width > 8 && rect.height > 8;
  };

  const usable = (button) => {
    const image = button?.querySelector?.("img");
    const src = image?.currentSrc || image?.src || "";
    return !!button && !!image && src && !src.startsWith("data:image/gif");
  };

  const repairCard = (card) => {
    const buttons = Array.from(card.querySelectorAll("button.callout-pip"));
    if (!buttons.length || buttons.some(visible)) return;
    const fallback = buttons.find(usable) || buttons[0];
    buttons.forEach((button) => {
      const active = button === fallback;
      button.hidden = !active;
      button.toggleAttribute("hidden", !active);
      button.classList.toggle("is-active", active);
    });
    if (fallback) {
      fallback.style.removeProperty("display");
      fallback.style.removeProperty("visibility");
      fallback.style.removeProperty("opacity");
    }
  };

  const repairAll = () => {
    document
      .querySelectorAll("#summer-products .card-js, #summer-running-caps .card-js")
      .forEach(repairCard);
    document.documentElement.setAttribute("data-two-nu-bogo-visible-pip-fallback", "ok");
  };

  const schedule = () => {
    repairAll();
    setTimeout(repairAll, 80);
    setTimeout(repairAll, 240);
    setTimeout(repairAll, 700);
    setTimeout(repairAll, 1600);
  };

  document.addEventListener("click", (event) => {
    if (event.target?.closest?.("#summer-products .swatch-wrapper, #summer-products [data-callout-v2-family], #summer-running-caps .swatch-wrapper")) {
      schedule();
    }
  }, false);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(() => schedule()).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["hidden", "class", "style"],
  });
})();
/* CODEX_BOGO_VISIBLE_PIP_ASSET_FALLBACK_20260703_END */
